module.exports = __webpack_public_path__ + "img/hys.d314a802.png";